export const requestTooltipPopperOptions = {
	modifiers: [
		{
			name: 'flip',
			options: {
				rootBoundary: 'viewport',
				fallbackPlacements: ['top', 'bottom'],
			},
		},
		{
			name: 'offset',
			options: {
				offset: ({ placement, reference, popper }) => {
					if (placement === 'bottom' || placement === 'top') {
						return [0, 0];
					}
					return [0, 200];
				},
			},
		},
	],
};

export const requestTooltipPopperOptionsDefault = (isHalf = false) => ({
	modifiers: [
		{
			name: 'flip',
			options: {
				rootBoundary: 'viewport',
			},
		},
		{
			name: 'offset',
			options: {
				offset: ({ placement, reference, popper }) => {
					if (placement === 'top' && placement === 'top') {
						return [0, 200];
					}
					if (isHalf) {
						return [0, 530];
					}
					return [0, 200];
				},
			},
		},
	],
});

export const requestTooltipPopperOptionsLow = {
	modifiers: [
		{
			name: 'flip',
			options: {
				rootBoundary: 'viewport',
				fallbackPlacements: ['top', 'bottom'],
			},
		},
		{
			name: 'offset',
			options: {
				offset: ({ placement }) => {
					if (placement === 'bottom' || placement === 'top') {
						return [-76, 0];
					}
					return [0, -200];
				},
			},
		},
	],
};
